import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { TextArea } from '@quantum-ecosystem/ui-toolkit';

const spacing = { xs: 8, sm: 12, md: 16, lg: 24, xl: 32 };
const withSpacing = (value) => typeof value === 'string' ? `${spacing[value] ?? value}px` : typeof value === 'number' ? `${value}px` : value;

const FormTextArea = forwardRef(({ label, withAsterisk, description, hint, error, mt, mb, w, size, style, wrapperClassName, minRows, maxRows, autosize, ...props }, ref) => (
	<TextArea
		ref={ref}
		size={['xs', 'sm'].includes(size) ? 'sm' : ['lg', 'xl'].includes(size) ? 'lg' : size}
		label={label && withAsterisk ? <>{label}<span className="q-form-required"> *</span></> : label}
		hint={hint ?? description}
		error={error || undefined}
		wrapperClassName={wrapperClassName}
		style={{ marginTop: withSpacing(mt), marginBottom: withSpacing(mb), width: withSpacing(w), ...style }}
		rows={props.rows ?? minRows ?? 3}
		{...props}
	/>
));

FormTextArea.displayName = 'FormTextArea';

FormTextArea.propTypes = {
	label: PropTypes.node,
	withAsterisk: PropTypes.bool,
	description: PropTypes.node,
	hint: PropTypes.node,
	error: PropTypes.node,
	mt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	mb: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	w: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	style: PropTypes.object,
	wrapperClassName: PropTypes.string,
	size: PropTypes.string,
	minRows: PropTypes.number,
	maxRows: PropTypes.number,
	autosize: PropTypes.bool,
};

export default FormTextArea;
